import { useState } from "react";
import { useDispatch } from "react-redux";
import { setIncident, setPost } from "services/redux/feedForm/feedForm";
import { AppDispatch } from "services/redux/store";
import { addFeedImg, logo, postKey } from "utils/assets_exports/images";
import { CustomComponentProps } from "utils/types/generalTypes";
export type FeedPostFixedTriggererProps = CustomComponentProps & {
    setOpenPostsModal: React.Dispatch<React.SetStateAction<boolean>>;
};
const FeedPostFixedTriggerer = ({
    setOpenPostsModal
}: FeedPostFixedTriggererProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [hideBtns, setHideBtns] = useState(true);

    const openPost = () => {
        dispatch(setPost());
        setHideBtns(true);
        setOpenPostsModal(true);
    };
    const openIncident = () => {
        dispatch(setIncident());
        setHideBtns(true);
        setOpenPostsModal(true);
    };

    return (
        <div className="fixed-trigger-post-btn">
            <div className={` ${hideBtns ? "is-hidden" : ""}`}>
                <div
                    className={`fixed-trigger-post-btn-dropdown d-flex flex-col flex-a-center flex-j-center gap-20 pb-20`}
                >
                    <img src={postKey} alt="" onClick={openPost} />
                    <img src={logo} alt="" onClick={openIncident} />
                </div>
            </div>

            <div className="trigrer">
                <img
                    src={addFeedImg}
                    alt=""
                    onClick={() => setHideBtns(() => !hideBtns)}
                />
            </div>
        </div>
    );
};

export default FeedPostFixedTriggerer;
